

const mediaprint = () => {
    return (
        `<style>
   
.printOrderPage {
    padding: 0;
    font-size: 100% !important;
    font-family: 'tahoma', 'sans-serif' !important;
    direction: rtl;
    line-height: 1.2rem;
}
.specialSpan span
{
line-height:1.5rem;
}
.bold {
    font-weight: bold;
}

.spaceLine {
    min-height: 5px;
    margin-top: 5px;
    margin-bottom: 5px;
}

.margeTop_5
{
margin-top:5px;
}

.margeTop_2
{
margin-top:2px;
}
.lineHegitBig
    {
    line-height:1.8rem;
    }
.spaceRight_5 {
 margin-right:5px;
}

.ms-panel-body,
.ms-panel-footer {
    position: relative;
    padding: 1.5rem;
}

.ms-identifier-widget .ms-panel-header h6,
.ms-identifier-widget .ms-panel-body p,
.ms-identifier-widget .ms-panel-body i {
    color: #fff;
}

.ms-identifier-widget .ms-panel-body p {
    margin: 3rem 0;
}

.ms-identifier-widget .ms-panel-body i::before {
    margin-top: 2rem;
    display: block;
    font-size: 3rem;
}

.ms-identifier-widget .ms-panel-body {
    display: flex;
    justify-content: center;
    align-items: center;
}
    .ms-invoice-table tr td,
.ms-invoice-table tr th {
  border: 1px solid #000; /* Change the color and width as needed */
  padding: 2px; /* Optional: add some padding for readability */
}

/* Optional: remove extra spacing between borders */
.ms-invoice-table {
  border-collapse: collapse;
}
tr {
    display: table-row;
    vertical-align: inherit;
    unicode-bidi: isolate;
    border-bottom:1px solid gray;
}
.ms-panel-header,
.ms-panel-body,
.ms-panel-footer {
    padding: 0.5rem;
}
    .thead-light thead {
    background-color: rgb(244, 244, 244);
}
   
.table-responsive {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}
    .table {
    width: 100%;
    margin-bottom: 1rem;
    color: #212529;
}
.ms-chat-conversations .ms-panel-body {
    max-height: 100vh;
}
.ms-email-panel .ms-panel-body {
    display: flex;
}

.ms-email-panel .ms-panel-body {
    flex-direction: column;
}

.ms-panel-body.order-circle h6 {
    margin-bottom: 20px;
    ;
}
.grayFrame {
    border: 1px solid gray;
    border-radius: 15px;
    padding: 15px 7px;
    margin-bottom: 10px;
}
.underline
{
text-decoration:underline;
}

.flexIt {
    display: flex;
}

.flex-Min {
    flex: 0;
}

.flex-half {
    flex: 0.5;
}

.flex-1 {
    flex: 1;
}

.flex-2 {
    flex: 2;
}

.flex-4 {
    flex: 4;
}

.flex-next {
    margin-right: 10px;
    margin-left: 10px;
}

.flex-Center {
    justify-content: center;
}
.halfBlock
{
    width: 50%;
}
.onRight {
    float: right;
}
.onLeft
{
 float: left;
}
.centerText
{
text-align:center;
}
.dotedLineBlack {
    padding-top: 5px;
    border-bottom: 1px dotted gray;
    margin-bottom: 5px;
}
.fullLine {
    padding-top: 5px;
    border-bottom: 1px solid gray;
    margin-bottom: 5px;
}

.dotedLine {
    padding-top: 5px;
    border-bottom: 1px dotted lightGray;
    margin-bottom: 5px;
}

.overflowHid {
    overflow: hidden;
}

.half {
    margin: 10px;
    width: calc(48% - 20px);
}

.spaceMargeRight_10 {
    margin-right: 10px;
}

.spaceMargeLeft_10 {
    margin-Left: 10px;
}
    
.spaceMargeLeft_20 {
    margin-Left: 20px;
}

.width_10perc
{
width: 10%;
}
.width_40perc {
    width: 75%;
}
.big {
    font-size: 120%;
}
    
.bigerr {
    font-size: 140%;
}
        
.regular {
    font-size: 100%;
}
        
.small ,.smallFont {
    font-size: 80%;
}

.fullRow {
    width: 100%;
    overflow: hidden;
}
    
.printingOrderLogo
{
width:150px;
height:150px;
position:relative;
}
.posRelative
{
position:relative;
}
</style>`
    )
}
export default { mediaprint } 